export default function <T extends ReadonlyArray<string>>(
  actionTypes: T,
  prefixes: string[] = [],
): Record<(typeof actionTypes)[number], string> {
  return actionTypes.reduce((prev, cur) => {
    return { ...prev, [cur]: [...prefixes, cur].join('/') };
  }, {} as Record<(typeof actionTypes)[number], string>);
}
